type TempoAuthorizeUrlParams = {
	clientId: string;
	redirectUri: string;
	verificationKey: string;
	jiraBaseUrl: string;
};

/**
 * Builds the URL that starts Tempo's OAuth consent flow. It uses Tempo's hosted authorize endpoint, which works
 * for both Forge and Connect installations of Tempo; the old Connect-only servlet path on the Jira site fails
 * with "Bundle error" once a site has moved to Forge.
 * See https://help.tempo.io/timesheets/latest/expected-changes-in-timesheets-on-forge
 *
 * The verification key travels inside the redirect URI so the callback can tie the token to the company.
 */
export const buildTempoAuthorizeUrl = ({
	clientId,
	redirectUri,
	verificationKey,
	jiraBaseUrl,
}: TempoAuthorizeUrlParams): string => {
	const params = new URLSearchParams({
		client_id: clientId,
		redirect_uri: `${redirectUri}?key=${verificationKey}`,
		jira_url: jiraBaseUrl.replace(/\/+$/, ''),
	});
	return `https://api.tempo.io/oauth/authorize/redirect?${params.toString()}`;
};
